import { render } from "./MatchEventView.vue?vue&type=template&id=d3d64a28&scoped=true"
import script from "./MatchEventView.vue?vue&type=script&lang=js"
export * from "./MatchEventView.vue?vue&type=script&lang=js"

import "./MatchEventView.vue?vue&type=style&index=0&id=d3d64a28&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3d64a28"]])

export default __exports__